/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        formField: {
            gap: {
                value: "8px",
                type: "dimension",
            },
            label: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                letterSpacing: {
                    value: "0.3px",
                    type: "dimension",
                },
            },
            help: {
                color: {
                    value: "#6f7377",
                    type: "color",
                },
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                letterSpacing: {
                    value: "0.3px",
                    type: "dimension",
                },
            },
            error: {
                gap: {
                    value: "4px",
                    type: "dimension",
                },
                color: {
                    value: "#921a1d",
                    type: "color",
                },
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                letterSpacing: {
                    value: "0.3px",
                    type: "dimension",
                },
                icon: {
                    width: {
                        value: "20px",
                        type: "dimension",
                    },
                    height: {
                        value: "20px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
